import React from 'react'
import { Form, Col, Row, InputGroup } from 'react-bootstrap'
import { getIn } from 'formik';

interface EventCompartsProps {
	name: string,
	value: string | number,
	touched: Object,
	errors: Object,
	errorPath?: string,
	onBlur?: {
		(e: React.FocusEvent<any>): void
	},
	onChange?: {
		(e: React.ChangeEvent<any>): void
	},
	onFocus?: {
		(e: React.FocusEvent<HTMLSelectElement>): void
	},
}

const showCoordErrors = (input_string: string, errors: Object, touched: Object): string => {
	let errorsList: Array<string> = [];
	let errorMsg = "";
	let errorObj = getIn(errors, input_string);
	let touchedObj = {};
	if (touched) {
		touchedObj = getIn(touched, input_string);
	}
	if (errorObj && touchedObj) {
		errorMsg = "Coordinates cannot be empty.";
		errorsList = Object.values(errorObj);
		errorsList.forEach((error: string) => {
			if (error === "invalid_var") {
				errorMsg = "Coordinates must be 0 or a positive integer.";
			}
		})
	}
	return (errorMsg);
}

// Custom 6-coordinate event component
export const EventCompart6 = ({
	name,
	value,
	touched,
	errors,
	errorPath,
	onBlur,
	onChange,
	onFocus,
	...props
}: EventCompartsProps) => {
	return (
		<>
			<Form.Label>C-voxel coordinates</Form.Label>
			<Row>
				<Col style={{ paddingRight: 2 }}>
					<InputGroup size="sm">
						<InputGroup.Prepend>
							<InputGroup.Text>X-1</InputGroup.Text>
						</InputGroup.Prepend>
						<Form.Control
							type="number"
							id="event-loc-x1"
							size="sm"
							name={name + `.xloc_1`}
							value={getIn(value, `xloc_1`)}
							isValid={getIn(touched, name + `.xloc_1`) &&
								!getIn(errors, errorPath || name + `.xloc_1`)}
							isInvalid={getIn(touched, name + `.xloc_1`) &&
								(!!getIn(errors, errorPath || name + `.xloc_1`) ||
									getIn(value, `xloc_1`) === "")}
							onChange={onChange}
							onBlur={onBlur} />
					</InputGroup>
					<InputGroup size="sm">
						<InputGroup.Prepend>
							<InputGroup.Text>Y-1</InputGroup.Text>
						</InputGroup.Prepend>
						<Form.Control
							type="number"
							id="event-loc-y1"
							size="sm"
							name={name + `.yloc_1`}
							value={getIn(value, `yloc_1`)}
							isValid={getIn(touched, name + `.yloc_1`) &&
								!getIn(errors, errorPath || name + `.yloc_1`)}
							isInvalid={getIn(touched, name + `.yloc_1`) &&
								(!!getIn(errors, errorPath || name + `.yloc_1`) ||
									getIn(value, `yloc_1`) === "")}
							onChange={onChange}
							onBlur={onBlur} />
					</InputGroup>
					<InputGroup size="sm">
						<InputGroup.Prepend>
							<InputGroup.Text>Z-1</InputGroup.Text>
						</InputGroup.Prepend>
						<Form.Control
							type="number"
							id="event-loc-z1"
							size="sm"
							name={name + `.zloc_1`}
							value={getIn(value, `zloc_1`)}
							isValid={getIn(touched, name + `.zloc_1`) &&
								!getIn(errors, errorPath || name + `.zloc_1`)}
							isInvalid={getIn(touched, name + `.zloc_1`) &&
								(!!getIn(errors, errorPath || name + `.zloc_1`) ||
									getIn(value, `zloc_1`) === "")}
							onChange={onChange}
							onBlur={onBlur} />
					</InputGroup>
				</Col>
				<Col style={{ paddingLeft: 2 }}>
					<InputGroup size="sm">
						<InputGroup.Prepend>
							<InputGroup.Text>X-2</InputGroup.Text>
						</InputGroup.Prepend>
						<Form.Control
							type="number"
							id="event-loc-x2"
							size="sm"
							name={name + `.xloc_2`}
							value={getIn(value, `xloc_2`)}
							isValid={getIn(touched, name + `.xloc_2`) &&
								!getIn(errors, errorPath || name + `.xloc_2`)}
							isInvalid={getIn(touched, name + `.xloc_2`) &&
								(!!getIn(errors, errorPath || name + `.xloc_2`) ||
									getIn(value, `xloc_2`) === "")}
							onChange={onChange}
							onBlur={onBlur} />
					</InputGroup>
					<InputGroup size="sm">
						<InputGroup.Prepend>
							<InputGroup.Text>Y-2</InputGroup.Text>
						</InputGroup.Prepend>
						<Form.Control
							type="number"
							id="event-loc-y2"
							size="sm"
							name={name + `.yloc_2`}
							value={getIn(value, `yloc_2`)}
							isValid={getIn(touched, name + `.yloc_2`) &&
								!getIn(errors, errorPath || name + `.yloc_2`)}
							isInvalid={getIn(touched, name + `.yloc_2`) &&
								(!!getIn(errors, errorPath || name + `.yloc_2`) ||
									getIn(value, `yloc_2`) === "")}
							onChange={onChange}
							onBlur={onBlur} />
					</InputGroup>
					<InputGroup size="sm">
						<InputGroup.Prepend>
							<InputGroup.Text>Z-2</InputGroup.Text>
						</InputGroup.Prepend>
						<Form.Control
							type="number"
							id="event-loc-z2"
							size="sm"
							name={name + `.zloc_2`}
							value={getIn(value, `zloc_2`)}
							isValid={getIn(touched, name + `.zloc_2`) &&
								!getIn(errors, errorPath || name + `.zloc_2`)}
							isInvalid={getIn(touched, name + `.zloc_2`) &&
								(!!getIn(errors, errorPath || name + `.zloc_2`) ||
									getIn(value, `zloc_2`) === "")}
							onChange={onChange}
							onBlur={onBlur} />
					</InputGroup>
				</Col>
			</Row>
			<Row className="justify-content-flex-center custom-error">
				<Col>{showCoordErrors(name, errors, touched)}</Col>
			</Row>
		</>
	)
}


// Custom 3-coordinate event component
export const EventCompart3 = ({
	name,
	value,
	touched,
	errors,
	errorPath,
	onBlur,
	onChange,
	onFocus,
	...props
}: EventCompartsProps) => {
	return (
		<>
			<Row className="justify-content-md-center">
				<Form.Label>C-voxel coordinates</Form.Label>
			</Row>
			<Row className="justify-content-md-center">
				<Col xs={6} style={{ paddingLeft: 10, paddingRight: 10 }}>
					<InputGroup size="sm">
						<InputGroup.Prepend>
							<InputGroup.Text>X</InputGroup.Text>
						</InputGroup.Prepend>
						<Form.Control
							type="number"
							id="event-loc-x"
							size="sm"
							name={name + `.xloc`}
							value={getIn(value, `xloc`)}
							isValid={getIn(touched, name + `.xloc`) &&
								!getIn(errors, errorPath || name + `.xloc`)}
							isInvalid={getIn(touched, name + `.xloc`) &&
								(!!getIn(errors, errorPath || name + `.xloc`) ||
									getIn(value, `xloc`) === "")}
							onChange={onChange}
							onBlur={onBlur} />
					</InputGroup>
					<InputGroup size="sm">
						<InputGroup.Prepend>
							<InputGroup.Text>Y</InputGroup.Text>
						</InputGroup.Prepend>
						<Form.Control
							type="number"
							id="event-loc-y"
							size="sm"
							name={name + `.yloc`}
							value={getIn(value, `yloc`)}
							isValid={getIn(touched, name + `.yloc`) &&
								!getIn(errors, errorPath || name + `.yloc`)}
							isInvalid={getIn(touched, name + `.yloc`) &&
								(!!getIn(errors, errorPath || name + `.yloc`) ||
									getIn(value, `yloc`) === "")}
							onChange={onChange}
							onBlur={onBlur} />
					</InputGroup>
					<InputGroup size="sm">
						<InputGroup.Prepend>
							<InputGroup.Text>Z</InputGroup.Text>
						</InputGroup.Prepend>
						<Form.Control
							type="number"
							id="event-loc-z"
							size="sm"
							name={name + `.zloc`}
							value={getIn(value, `zloc`)}
							isValid={getIn(touched, name + `.zloc`) &&
								!getIn(errors, errorPath || name + `.zloc`)}
							isInvalid={getIn(touched, name + `.zloc`) &&
								(!!getIn(errors, errorPath || name + `.zloc`) ||
									getIn(value, `zloc`) === "")}
							onChange={onChange}
							onBlur={onBlur} />
					</InputGroup>
				</Col>
			</Row>

			<Row className="justify-content-flex-center custom-error">
				<Col>{showCoordErrors(name, errors, touched)}</Col>
			</Row>
		</>
	)
}
